import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import { UserModesService } from '../../user_modes/user_modes_service';

angular
  .module('lib')
  .service(
    'acceptTOUCommand',
    (
      defineCommandORM: IDefineCommand,
      $state: ng.ui.IStateService,
      accountModel: AccountModel,
      $http: ng.IHttpService,
      ngUserModesService: UserModesService
    ) => {
      return defineCommandORM('acceptTOUCommand', (deferred) => {
        const navigateAfterAcceptance = () => {
          $state.go(`user-modes`);
        };

        if (accountModel.acceptedTerms) {
          return navigateAfterAcceptance();
        }

        $http
          .post('/core/tandc/', {
            tandc_accepted: true
          })
          .then((response: { data: { tandc_accepted: boolean } }) => {
            if (response.data.tandc_accepted) {
              accountModel.acceptedTerms = true;
            }

            ngUserModesService.processDefaultMode();
          })
          .finally(() => {
            navigateAfterAcceptance();
            deferred.resolve();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/tos/commands/accept_tou_command.ts